<template src="./index.html"></template>

<script>
import { getdata } from './data.js';
import mskInfo from './mskInfo/index.vue'
import InvoiceInfo from './InvoiceInfo/index.vue'
export default {
	components:{
		mskInfo,
		InvoiceInfo,
	},
	data() {
		return {
			activeName:"mskInfo"
		};
	},
	mounted() {
	
	},
	created() {},
	methods: {
		forRouter(){
		
		}
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
